module.exports = __webpack_public_path__ + "static/media/icono_medalla_fondo.9dd032f3.svg";